
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suburb-finder",
      function () {
        return require("private-next-pages/suburb-finder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suburb-finder"])
      });
    }
  